export const msalConfig = {
  auth: {
    clientId: process.env.VUE_APP_AZURE_AD_CLIENT_ID || '',
    authority: process.env.VUE_APP_AZURE_AD_AUTHORITY || '',
    redirectUri: process.env.VUE_APP_AZURE_AD_REDIRECT_URI || window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    allowRedirectInIframe: true
  }
};

export const loginRequest = {
  scopes: [`${process.env.VUE_APP_AZURE_AD_CLIENT_ID}/.default`]
};
